module.exports = __webpack_public_path__ + "static/media/CAM LEVER482-00716MACHINES.6d9c49fd.jpg";